"use client";
import {
  useHovercard
} from "../__chunks/6YZEXKNV.js";
import "../__chunks/YMV43K4F.js";
import "../__chunks/BYD75WXE.js";
import {
  createDialogComponent
} from "../__chunks/KXSO5EFT.js";
import "../__chunks/3N4FFVWW.js";
import "../__chunks/NOYDL3YS.js";
import "../__chunks/BULCTPRV.js";
import "../__chunks/6BJGLK2C.js";
import "../__chunks/CS347UVZ.js";
import "../__chunks/IUB2BTEK.js";
import "../__chunks/XHJGS6Z5.js";
import "../__chunks/TL67WVI6.js";
import "../__chunks/MKDDWKFK.js";
import "../__chunks/72E5EPFF.js";
import "../__chunks/OOBDFMJL.js";
import "../__chunks/X6WIMZJE.js";
import "../__chunks/677M2CI3.js";
import "../__chunks/6GXEOXGT.js";
import "../__chunks/WCIYB4YS.js";
import "../__chunks/UYRJLDVS.js";
import "../__chunks/CK3UW3AQ.js";
import "../__chunks/WKWX2XLD.js";
import "../__chunks/7452U3HH.js";
import "../__chunks/XPF5GU3Q.js";
import "../__chunks/CBTO7DFZ.js";
import "../__chunks/RQZGFHI2.js";
import {
  TooltipScopedContextProvider,
  useTooltipProviderContext
} from "../__chunks/3OMHZVJD.js";
import "../__chunks/TWDHCE7Y.js";
import "../__chunks/TE637IA7.js";
import "../__chunks/XXVAHUAO.js";
import "../__chunks/J55AVALY.js";
import "../__chunks/WAZE6NXP.js";
import "../__chunks/SHA3WOPI.js";
import "../__chunks/IFT5JEUU.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/5M6RSQEC.js";
import "../__chunks/I62TROYO.js";
import "../__chunks/HZJ2XALY.js";
import "../__chunks/EKQEJRUF.js";
import {
  useWrapElement
} from "../__chunks/6O5OEQGF.js";
import "../__chunks/XM66DUTO.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "../__chunks/4R3V3JGP.js";

// src/tooltip/tooltip.tsx
import { contains } from "@ariakit/core/utils/dom";
import { invariant, isFalsyBooleanCallback } from "@ariakit/core/utils/misc";
import { jsx } from "react/jsx-runtime";
var TagName = "div";
var useTooltip = createHook(
  function useTooltip2(_a) {
    var _b = _a, {
      store,
      portal = true,
      gutter = 8,
      preserveTabOrder = false,
      hideOnHoverOutside = true,
      hideOnInteractOutside = true
    } = _b, props = __objRest(_b, [
      "store",
      "portal",
      "gutter",
      "preserveTabOrder",
      "hideOnHoverOutside",
      "hideOnInteractOutside"
    ]);
    const context = useTooltipProviderContext();
    store = store || context;
    invariant(
      store,
      process.env.NODE_ENV !== "production" && "Tooltip must receive a `store` prop or be wrapped in a TooltipProvider component."
    );
    props = useWrapElement(
      props,
      (element) => /* @__PURE__ */ jsx(TooltipScopedContextProvider, { value: store, children: element }),
      [store]
    );
    const role = store.useState(
      (state) => state.type === "description" ? "tooltip" : "none"
    );
    props = __spreadValues({ role }, props);
    props = useHovercard(__spreadProps(__spreadValues({}, props), {
      store,
      portal,
      gutter,
      preserveTabOrder,
      hideOnHoverOutside(event) {
        if (isFalsyBooleanCallback(hideOnHoverOutside, event))
          return false;
        const anchorElement = store == null ? void 0 : store.getState().anchorElement;
        if (!anchorElement)
          return true;
        if ("focusVisible" in anchorElement.dataset)
          return false;
        return true;
      },
      hideOnInteractOutside: (event) => {
        if (isFalsyBooleanCallback(hideOnInteractOutside, event))
          return false;
        const anchorElement = store == null ? void 0 : store.getState().anchorElement;
        if (!anchorElement)
          return true;
        if (contains(anchorElement, event.target))
          return false;
        return true;
      }
    }));
    return props;
  }
);
var Tooltip = createDialogComponent(
  forwardRef(function Tooltip2(props) {
    const htmlProps = useTooltip(props);
    return createElement(TagName, htmlProps);
  }),
  useTooltipProviderContext
);
export {
  Tooltip,
  useTooltip
};
